import React from 'react';
import { CrestronControl } from './pages/CrestronControl';
export function App() {
  return <div className="min-h-screen bg-black flex items-center justify-center p-4" data-id="element-0">
      {/*
          Container to simulate iPad viewport on larger screens
          In a real deployment, this would be full screen on the device
        */}
      <CrestronControl data-id="element-1" />
    </div>;
}